export default {"src":"https://haomao.wukongedu.net/_next/static/media/logo-red.e14f9308.svg","height":30,"width":90};